var NavigationAlignments = {
  Leading: 'ALIGNMENTS/LEADING',
  Trailing: 'ALIGNMENTS/TRAILING'
};
var sidesheetDefaultValues = {
  navigationAlignment: NavigationAlignments.Leading,
  shouldUseDynamicPadding: false,
  panelWidths: {
    Mobile: '100vw',
    Tablet: '375px',
    Desktop: '480px',
    WideScreen: '560px',
    UltraWideScreen: '640px'
  }
};

export { NavigationAlignments, sidesheetDefaultValues };
